module.exports = { id: "backmotor", url: "/build/app/img/symbols.svg#backmotor", viewBox: "", toString: function() { return this.url; } };